import { useEffect, useState } from "react";
import "./timeOutModal.scss";
const TimeOutModal = ({
    openTimeoutModal,
    setOpenTimeoutModal,
}) => {
    const [counter, setCounter] = useState(10);
    const handleTabClose = () => {
        window.close();
        setOpenTimeoutModal(false)
    }

    useEffect(()=>{
        if(counter <= 0 ) {
            handleTabClose();
            window.location.reload()
        }
    },[counter])

    useEffect(()=>{
        let id;
        if(openTimeoutModal) {
            id = setInterval(()=>{
                setCounter(prev=> {
                    if(prev > 0)
                      return  prev-1
                    else 
                    {
                        clearInterval(id);
                        return prev
                    }
            })
                
            },1000);
        }

        return () => clearInterval(id);
    },[openTimeoutModal])
    if(!openTimeoutModal)
        return <></>
    return (
        <div className="client-custom-time-out-modal-main-container" id="popup">
            <div className="popup-box">
                <div className="popup-header">
                    <h2>Session Expired!</h2>
                    <span className="close-btn" onClick={()=>setOpenTimeoutModal(false)}>×</span>
                </div>
                <div className="divider"></div>
                <div className="popup-body">
                    <p>This tab will be closed automatically in <span id="timer">{counter}</span> seconds</p>
                    <div className="popup-footer">
                        <button onClick={handleTabClose}>Close Now</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default TimeOutModal;